import { AntTag } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { DASH } from 'modules/constants'
import { refetchFunc } from 'modules/domain/common/hooks'
import { formatQuantity } from 'modules/utils/numbers/formatQuantity'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UserLink } from 'views/components/UserLink/UserLink'
import { LaboratoryCodes, SampleRequestType } from 'views/pages/Samples/types'
import APhone from 'views/ui/Phone/APhone'
import { SamplesCommonTable } from '../SamplesCommonTable'
import { RowGapWrapper } from '../styled'
import { EditSampleRequestModal } from './EditSampleRequestModal'
import { ARouterLink } from 'views/components/Analytics'
import { generatePath } from 'react-router-dom'
import SamplesRoutes from 'views/pages/Samples/routes'

type Props = {
  sampleRequest: SampleRequestType
  sampleRequestRefetch: refetchFunc
}

export const SampleRequest: FC<Props> = ({ sampleRequest, sampleRequestRefetch }) => {
  const { t } = useTranslation(['deal', 'samples'])
  const formateDate = useFormatDate()
  const [editSampleRequest, setEditSampleRequest] = useState(false)

  const labInfo =
    sampleRequest.laboratory === LaboratoryCodes.other
      ? sampleRequest.lab_comment
      : t(`samples:laboratories.${sampleRequest.laboratory}`)

  const labAssistant = `${t('accordion.sample.labAssistant')}: ${
    sampleRequest.lab_assistant ? sampleRequest.lab_assistant.full_name : DASH
  }`

  const sampleLink = (
    <ARouterLink eventName="sample_detail" to={generatePath(SamplesRoutes.Details, { id: sampleRequest.sample })}>
      {`${t('accordion.sample.id')} ${sampleRequest.sample}`}
    </ARouterLink>
  )

  const requestOpt = [
    { label: t('accordion.sample.seniorRegional'), value: sampleRequest.senior_regional?.full_name },
    {
      label: t('accordion.sample.info'),
      value: (
        <>
          {sampleLink}, &nbsp;
          {`${sampleRequest.product?.title}, ${formatQuantity(sampleRequest.quantity as number)}`}
        </>
      ),
    },
    { label: t('accordion.sample.from'), value: sampleRequest.seller_address?.address },
    {
      label: t('accordion.sample.to'),
      value: (
        <div>
          <div>{labInfo}</div>
          <div>{labAssistant}</div>
          <div>
            {t('samples:analysis_type')}:{' '}
            {sampleRequest.analysis_type ? t(`samples:analysisTypes.${sampleRequest.analysis_type}`) : DASH}
          </div>
        </div>
      ),
    },
    {
      label: t('accordion.sample.contact'),
      value: (
        <RowGapWrapper rowGap={4}>
          <UserLink user={sampleRequest.seller_user} />
          <APhone phone={sampleRequest.seller_user?.phone || DASH} />
        </RowGapWrapper>
      ),
    },
    {
      label: t('common:comment'),
      value: sampleRequest.comment || DASH,
    },
    {
      label: t('common:createdBy'),
      value: sampleRequest.created_by.full_name,
    },
  ]

  return (
    <>
      <SamplesCommonTable
        editBtnId="editRequest"
        editModalHandler={() => setEditSampleRequest(true)}
        header={
          <AntTag color="purple">{`${t('common:bid')} ${t('common:from')} ${formateDate(sampleRequest.created, {
            withTime: true,
          })}`}</AntTag>
        }
        options={requestOpt}
      />

      {editSampleRequest && (
        <EditSampleRequestModal
          sampleRequest={sampleRequest}
          refetch={sampleRequestRefetch}
          onClose={() => setEditSampleRequest(false)}
        />
      )}
    </>
  )
}
